import { useMutation } from '@tanstack/react-query'
import { useCartContext } from '../components'
import { useRecentlyAddedProducts } from './useRecentlyAddedProducts'
import { AddCartItemPayload, Cart } from '../types'

export const useAddCartItems = (args?: {
  onSuccess?: (data: Cart, variables: AddCartItemPayload[]) => void
  useRecentlyAdded?: boolean
}) => {
  const { onSuccess, useRecentlyAdded = true } = args ?? {}
  const setRecentlyAddedProductIds = useRecentlyAddedProducts(
    ({ setRecentlyAddedProductIds }) => setRecentlyAddedProductIds,
  )

  const { cartManager, recentlyAddedTimer } = useCartContext()

  return useMutation({
    mutationFn: cartManager.addItems,
    onMutate: () => {
      if (useRecentlyAdded) {
        setRecentlyAddedProductIds([])
      }
    },
    onSuccess: (data, variables) => {
      if (onSuccess) {
        onSuccess(data, variables)
      }

      if (useRecentlyAdded) {
        setRecentlyAddedProductIds(variables.map((item) => item.id))
        recentlyAddedTimer.start()
      }
    },
  })
}
